import { Redirect, RouteProps } from 'react-router-dom';
import React, { FC } from 'react';
import { useAtomValue } from 'jotai';
import { clearState, portalLoginStatus, portalSso } from '@/state/portalAuth';
import { SentryRoute } from '@/sentry';
import routes from '@/components/portal/routes';
import EventAwareRoute from '@/components/portal/EventAwareRoute';

export type AuthenticatedRouteProps = RouteProps;

/**
 * A route which redirects to the login page if the current user is logged out.
 */
const AuthenticatedRoute: FC<AuthenticatedRouteProps> = (props) => {
  const loginStatus = useAtomValue(portalLoginStatus);
  const sso = useAtomValue(portalSso);

  switch (loginStatus) {
    case 'LOGGED_OUT':
      if (sso?.registrationId) {
        clearState();

        return (
          <Redirect
            to={routes.sessionExpiredSso.replace(
              ':registrationId',
              sso.registrationId,
            )}
          />
        );
      }

      return <Redirect to={routes.login} />;
    case 'AUTHENTICATED':
      return <EventAwareRoute {...props} />;
    default:
      return <SentryRoute {...props} />;
  }
};

export default AuthenticatedRoute;
